import { Action } from "redux";
import { OrganizationKeyName } from "../../../model/Organization";
import { OrganizationUISettings } from "../../../model/OrganizationUISettings";

export const GET_UI_SETTINGS_SUCCESS = "ORGANIZATION:GET_UI_SETTINGS_SUCCESS";

export interface GetUISettingsSuccessAction extends Action {
  type: typeof GET_UI_SETTINGS_SUCCESS;
  organization: OrganizationKeyName;
  data: OrganizationUISettings;
}

export const getUISettingsSuccess = (
  organization: OrganizationKeyName,
  data: OrganizationUISettings
): GetUISettingsSuccessAction => ({
  type: GET_UI_SETTINGS_SUCCESS,
  data,
  organization,
});
